import { useTranslation } from 'react-i18next';
import {
  TermsConditionsWrapper,
  TitlePage,
  TermsConditionsRuleText,
  TitleSection,
  SectionList,
} from 'containers/termsAndConditions/styled';

export const TermsAndConditions = () => {
  const { t } = useTranslation();
    
  return ( 
    <TermsConditionsWrapper>
      <TitlePage>{t('termsAndConditions')}</TitlePage>
      <TermsConditionsRuleText>{t('welcomeToItah')}</TermsConditionsRuleText>
      <TermsConditionsRuleText>{t('rulesInItah')}</TermsConditionsRuleText>
      <TermsConditionsRuleText>{t('byAccessing')}</TermsConditionsRuleText>
      <TermsConditionsRuleText>{t('terminalogyApplies')}</TermsConditionsRuleText>
      <TitleSection>{t('cookies')}</TitleSection>
      <TermsConditionsRuleText>{t('weEmployUseOfCookies')}</TermsConditionsRuleText>
      <TermsConditionsRuleText>{t('enableFunctionalityOfAreas')}</TermsConditionsRuleText>
      <TitleSection>{t('License')}</TitleSection>
      <TermsConditionsRuleText>{t('aboutLicense')}</TermsConditionsRuleText>
      <TitleSection>{t('youMustNot')}</TitleSection>
      <SectionList>{t('republishFromItah')}</SectionList>
      <SectionList>{t('sellRentSubLicense')}</SectionList>
      <SectionList>{t('reproduceMaterial')}</SectionList>
      <SectionList>{t('findAndPreventContent')}</SectionList>
      <SectionList>{t('aboutAgreement')}</SectionList>
      <TermsConditionsRuleText>{t('partsOfWebsite')}</TermsConditionsRuleText>
      <TermsConditionsRuleText>{t('notRemoveComments')}</TermsConditionsRuleText>
      <TermsConditionsRuleText>{t('youWarrantAndRepresent')}</TermsConditionsRuleText>
      <SectionList>{t('postComments')}</SectionList>
      <SectionList>{t('commentsNotInvade')}</SectionList>
      <SectionList>{t('commentsNotContainMaterial')}</SectionList>
      <SectionList>{t('commentNotPromoteBusiness')}</SectionList>
      <SectionList>{t('editOfComments')}</SectionList>
      <TitleSection>{t('hyperlinkToComment')}</TitleSection>
      <TermsConditionsRuleText>{t('OrganizationsMayLink')}</TermsConditionsRuleText>
      <SectionList>{t('governmentAgencies')}</SectionList>
      <SectionList>{t('searchEngines')}</SectionList>
      <SectionList>{t('newsOrganizations')}</SectionList>
      <SectionList>{t('searchEngines')}</SectionList>
      <TermsConditionsRuleText>{t('onlineDirectory')}</TermsConditionsRuleText>
      <TermsConditionsRuleText>{t('considerAndApprove')}</TermsConditionsRuleText>
      <SectionList>{t('commonlyKnown')}</SectionList>
      <SectionList>{t('communitySites')}</SectionList>
      <SectionList>{t('representingCharities')}</SectionList>
      <SectionList>{t('onlineDirectoryDistributors')}</SectionList>
      <SectionList>{t('internetPortals')}</SectionList>
      <SectionList>{t('accountingAssociations')}</SectionList>
      <TermsConditionsRuleText>{t('approveLinkRequests')}</TermsConditionsRuleText>
      <TermsConditionsRuleText>{t('organizationsLink')}</TermsConditionsRuleText>
      <TermsConditionsRuleText>{t('interestedLinking')}</TermsConditionsRuleText>
      <TermsConditionsRuleText>{t('hyperlinkToWebsite')}</TermsConditionsRuleText>
      <SectionList>{t('useOfOurCorporate')}</SectionList>
      <SectionList>{t('uniformResource')}</SectionList>
      <SectionList>{t('byUseOfDescription')}</SectionList>
      <SectionList>{t('noUseOfITAHLogo')}</SectionList>
      <TitleSection>{t('iframes')}</TitleSection>
      <TermsConditionsRuleText>{t('withoutApproval')}</TermsConditionsRuleText>
      <TitleSection>{t('contentLiability')}</TitleSection>
      <TermsConditionsRuleText>{t('notResponsibleForContent')}</TermsConditionsRuleText>
      <TitleSection>{t('yourPrivacy')}</TitleSection>
      <TermsConditionsRuleText>{t('readPrivacyPolicy')}</TermsConditionsRuleText>
      <TitleSection>{t('reservationOfRights')}</TitleSection>
      <TermsConditionsRuleText>{t('reserveTheRight')}</TermsConditionsRuleText>
      <TitleSection>{t('removalOfLinks')}</TitleSection>
      <TermsConditionsRuleText>{t('offensiveLinks')}</TermsConditionsRuleText>
      <TermsConditionsRuleText>{t('websiteInfoCorrect')}</TermsConditionsRuleText>
      <TitleSection>{t('disclaimer')}</TitleSection>
      <TermsConditionsRuleText>{t('maximumExtent')}</TermsConditionsRuleText>
      <SectionList>{t('limitLiability')}</SectionList>
      <SectionList>{t('limitMisrepresentation')}</SectionList>
      <SectionList>{t('byUseOfLimit')}</SectionList>
      <SectionList>{t('excludeLiabilities')}</SectionList>
      <SectionList>{t('limitationsInThisSection')}</SectionList>
      <TermsConditionsRuleText>{t('asLongAsWebsite')}</TermsConditionsRuleText>
    </TermsConditionsWrapper>
  );
};
